import { Box } from "@mui/material";
import styled from "styled-components";

export const DebtChartContainer = styled(Box)`
    height:216px;
    margin-top: 32px;
    width: 100%;
`;